import React, { useEffect } from 'react'
import { NavBar } from '../../components-pos/NavSections'

export default function SettingIndex(props) {
  useEffect(() => {
    props.history.push('/pos/setting/system')
  }, [])
}

export function NavLinks(props) {
  const links = [
    { name: '시스템 관리', path: '/pos/setting/system' },
    { name: '기초코드 관리', path: '/pos/setting/menu-codes' },
  ]
  return <NavBar {...props} links={links} />
}
